<template>
  <div>
    <Label :htmlFor="id" medium>ログインID（メールアドレス）</Label>
    <EmailInput :id="id" v-model="inputEmail" width="312"> </EmailInput>
  </div>
</template>

<script>
import EmailInput from '@/components/_atoms/inputs/EmailInput.vue';
import Label from '@/components/_atoms/labels/Label.vue';

export default {
  name: 'LabelEmailInput',
  components: {
    EmailInput,
    Label
  },
  model: { prop: 'emailText', event: 'email' },
  props: {
    id: { type: String, required: false },
    emailText: { type: String, default: '' }
  },
  computed: {
    inputEmail: {
      get() {
        return this.emailText;
      },
      set(val) {
        this.$emit('email', val);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_molecules/LabelEmailInput.vue